import { render, staticRenderFns } from "./list_item1.vue?vue&type=template&id=32577e2d&scoped=true&"
import script from "./list_item1.vue?vue&type=script&lang=js&"
export * from "./list_item1.vue?vue&type=script&lang=js&"
import style0 from "./list_item1.vue?vue&type=style&index=0&id=32577e2d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32577e2d",
  null
  
)

export default component.exports